module.exports = __webpack_public_path__ + "static/media/Vectorlim_eye.1f83f4ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Vectorlim_eye.svg
// module id = 417
// module chunks = 1